import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

export const StyledButtonWrapper = styled(Button)(
  ({ variant }: ButtonProps) => ({
    backgroundColor:
      variant === 'outlined' ? 'var(--new-cream)' : 'var(--new-accent-primary)',
    borderRadius: '5px',
    padding: '16px 40px',
    textTransform: 'none',
    boxShadow: 'none',
    height: '56px',
    marginBottom: '16px',
    border: '1.5px solid var(--new-accent-primary) ',
    color:
      variant === 'outlined' ? 'var(--accent-primary)' : 'var(--new-cream)',
    '&:active': {
      backgroundColor: 'var(--neutral-secondary) ',
    },
    '&:disabled': {
      backgroundColor: 'var(--neutral-secondary-darker) ',
      color: 'var(--neutral-secondary) ',
      border: 'none',
    },
    '&:hover': {
      border: '1.5px solid var(--new-accent-primary) ',
      backgroundColor:
        variant === 'outlined'
          ? 'var(--new-cream)'
          : 'var(--new-accent-primary)',
      boxShadow: 'none',
    },
    span: {
      fontFamily: 'var(--new-font)',
      fontStyle: 'normal',
      fontWeight: 400,
    },
    '&.copy-button': {
      height: '40px',
      padding: '0px 8px',
      marginTop: '16px',
      marginBottom: '0px',
      fontSize: '14px',
      '@media (max-width: 500px)': {
        display: 'block',
        marginBottom: '16px',
      },
    },
  }),
);
